export default [
  {
    path: "/seasonality-events",
    name: "seasonality-events",
    icon: "calendar",
    component: () => import("@/views/seasonalityEvents/SeasonalityEventsPage.vue"),
    meta: {
      title: "Seasonality Events",
      ability: {
        action: ["read", "create"],
        subject: "SeasonalityEvents",
      },
    },
  },
];
